// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1YJZL","additionalInfo":"AgreementModal_additionalInfo__1necI"};